import { render, staticRenderFns } from "./DocumentPage2.vue?vue&type=template&id=3b707204&scoped=true"
import script from "./DocumentPage2.vue?vue&type=script&lang=js"
export * from "./DocumentPage2.vue?vue&type=script&lang=js"
import style0 from "./DocumentPage2.vue?vue&type=style&index=0&id=3b707204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b707204",
  null
  
)

export default component.exports